import * as Yup from "yup";

export const schema = Yup.object({
  name: Yup.string().required("Campo obrigatório."),
  combo: Yup.string().required("Campo obrigatório."),
  plan: Yup.number().required("Campo obrigatório."),
  fidelityDuration: Yup.number()
    .min(0, "A duração mínima de fidelidade é nenhum mês.")
    .max(36, "A duração máxima de fidelidade é 36 meses.")
    .required("Campo obrigatório."),
  operations: Yup.array()
    .of(Yup.number())
    .min(1, "Campo obrigatório.")
    .required("Campo obrigatório.")
});

export const additionalSchemaDefault = Yup.object({
  name: Yup.string().required("Obrigatório."),
  activationValue: Yup.string().required("Obrigatório."),
  monthlyFee: Yup.string().required("Obrigatório."),
  additionalId: Yup.number().nullable()
});

export const additionalSchemaBonus = additionalSchemaDefault.shape({
  bonus: Yup.number()
    .typeError("Bônus deve ser um número.")
    .required("Obrigatório.")
});

export const additionalSchemaProduct = additionalSchemaDefault.shape({
  productId: Yup.number().required("Obrigatório.")
});

export const editOfferSchema = Yup.object({
  name: Yup.string().required("Campo obrigatório.")
});
